// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0eebcfbc","455":"deae3072"}[chunkId] + ".chunk.js";
};